import React, { useEffect } from 'react';
import './Gallery.css';

const GalleryItem = ({ type, src, title, planUrl, colSpan, isVertical, children }) => {
  const itemStyle = colSpan ? { flex: `0 0 ${colSpan * 25}%`, maxWidth: `${colSpan * 25}%` } : {};
  const verticalStyle = isVertical ? { display: 'flex', flexDirection: 'column', gap: '10px' } : {};

  if (type === 'div' && children) {
    return (
      <div className="gLPewc" style={itemStyle}>
        <div className="bbOsHr" style={verticalStyle}>
          {children.map((child, index) => (
            <div key={index} className={child.type === 'video' ? 'fiigrn' : 'bPvfCa'}>
              <a className="planLink" href={planUrl} rel="nofollow">
                {child.type === 'video' ? (
                  <>
                    <video 
                      src={child.src} 
                      muted 
                      autoPlay 
                      playsInline 
                      loop 
                      width="100%" 
                      height="auto"
                    />
                    <div className="fvTDpW">
                      <div className="cLzZIr"></div>
                    </div>
                  </>
                ) : (
                  <img src={child.src} title={child.title} className="gQCKeh" alt={child.title || ''} />
                )}
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="gLPewc" style={itemStyle}>
      <div className="bbOsHr">
        <div className={type === 'video' ? 'fiigrn' : 'bPvfCa'}>
          <a className="planLink" href={planUrl} rel="nofollow">
            {type === 'video' ? (
              <>
                <video 
                  src={src} 
                  muted 
                  autoPlay 
                  playsInline 
                  loop 
                  width="100%" 
                  height="auto"
                />
                <div className="fvTDpW">
                  <div className="cLzZIr"></div>
                </div>
              </>
            ) : (
              <img src={src} title={title} className="gQCKeh" alt={title} />
            )}
          </a>
        </div>
      </div>
    </div>
  );
};

const GalleryRow = ({ items, planUrl }) => {
  return (
    <div className="lnbDME">
      {items.map((item, index) => (
        <GalleryItem key={index} {...item} planUrl={planUrl} />
      ))}
    </div>
  );
};

const Gallery = ({ finalPlanUrl, assetBaseUrl }) => {
  useEffect(() => {
    // 移除 URL 參數處理邏輯，因為我們現在使用固定的 URL
    const handleUrlParams = () => {
      // 處理優惠券圖片
      const imgElements = document.querySelectorAll('img[title="coupon"]');
      imgElements.forEach(img => {
        const src = img.src;
        img.onerror = () => {
          img.src = src.replace(/(\d+)\..*\.png$/, '$1.png');
        };
      });
    };

    handleUrlParams();
  }, []);

  return (
    <div className="hOKUVn">
      <div className="feLbMY"></div>
      <div className="dFWqpU">
        <GalleryRow items={[
          { type: 'image', src: `${assetBaseUrl}/1-1.jpg` },
          { type: 'image', src: `${assetBaseUrl}/1-2.jpg` },
          { type: 'image', src: `${assetBaseUrl}/1-3.jpg` },
          { type: 'image', src: `${assetBaseUrl}/1-4.jpg`, title: 'coupon' }
        ]} planUrl={finalPlanUrl} />
        <GalleryRow items={[
          { type: 'image', src: `${assetBaseUrl}/2-1.jpg` },
          { type: 'image', src: `${assetBaseUrl}/2-2.jpg` },
          { type: 'image', src: `${assetBaseUrl}/2-3.jpg` },
          { type: 'image', src: `${assetBaseUrl}/2-4.jpg` } 
        ]} planUrl={finalPlanUrl} />
        <GalleryRow items={[
          { type: 'image', src: `${assetBaseUrl}/3-1.jpg`, title: 'coupon' },
          { type: 'image', src: `${assetBaseUrl}/3-2.jpg` },
          { type: 'image', src: `${assetBaseUrl}/3-3.jpg` },
          { type: 'image', src: `${assetBaseUrl}/3-4.jpg` }
        ]} planUrl={finalPlanUrl} />
        <GalleryRow items={[
          { type: 'image', src: `${assetBaseUrl}/4-1.jpg` },
          { type: 'image', src: `${assetBaseUrl}/4-2.jpg` },
          { type: 'image', src: `${assetBaseUrl}/4-3.jpg` },
          { type: 'image', src: `${assetBaseUrl}/4-4.jpg` }
        //   { type: 'div', isVertical: true, children: [ // 使用 div 包裝 4.3.1 和 4.3.2
        //     { type: 'image', src: 'https://images.modelmediaasia.com/landing/4.3.1.jpg' },
        //     { type: 'video', src: 'https://images.modelmediaasia.com/landing/4.3.2.mp4' }
        //   ]
        // }
        ]} planUrl={finalPlanUrl} />
        <GalleryRow items={[
          { type: 'image', src: `${assetBaseUrl}/5-1.jpg` },
          { type: 'image', src: `${assetBaseUrl}/5-2.jpg` },
          { type: 'image', src: `${assetBaseUrl}/5-3.jpg` },
          { type: 'image', src: `${assetBaseUrl}/5-4.jpg` }
        ]} planUrl={finalPlanUrl} />
      </div>
      <div className="feLbMY"></div>
      <div className="cTxeDb getAccessButton">
        <div className="bbOsHr">
          <div className="bPvfCa">
            <a className="planLink" href={finalPlanUrl} rel="nofollow">
              <img src={`${assetBaseUrl}/GetAccess.jpg`} title="" className="gQCKeh" alt="get access" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery; 